import z from "zod";
import { Gender } from "@/openapi/generated";
import { phoneZodField } from "@/schemas/shared/phone-field-schema";

export const parentEditFormSchema = z.object({
  firstName: z.string().min(1, { message: "First name is required" }),
  lastName: z.string().min(1, { message: "Last name is required" }),
  email: z.string().refine((val) => /\S+@\S+\.\S+/.test(val), {
    message: "Please enter a valid email address",
  }),
  cellPhone: phoneZodField,
  address: z.string().optional().nullable(),
  city: z.string().optional().nullable(),
  state: z.string().optional().nullable(),
  zip: z.string().optional().nullable(),
  country: z.string().optional().nullable(),
  gender: z
    .string()
    .optional()
    .nullable()
    .refine(
      (val) =>
        val === undefined ||
        val === null ||
        val === "" ||
        val === Gender.Male ||
        val === Gender.Female ||
        val === Gender.Other,
      { message: "Invalid gender" }
    ),
  birthday: z
    .object({
      day: z.string(),
      month: z.string(),
      year: z.string(),
    })
    .optional()
    .nullable(),
  locations: z.array(z.string()).optional(),
});

export type ParentEditFormSchemaType = z.infer<typeof parentEditFormSchema>;
